// extracted by mini-css-extract-plugin
export default {"container":"filterBar_container__5Ie4p","categoryDiv":"filterBar_categoryDiv__LIOCY","newCategory":"filterBar_newCategory__M-sd7","errorLabel":"filterBar_errorLabel__XKBvh"};